import {
   
    SAVE_TOKEN_STARTED,
    SAVE_TOKEN_COMPLETED,
    SAVE_TOKEN_FAILED,
    
   
} from '../actions/Token';

const intialTOKENData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    TOKENInput: {       
        userId: "",
        password: "",
        securityQuestion: "",
        answer: "",
        roleFkId:{roleId:0,roleName:"",description:"",status:0,createdAt:"",createdBy:"",updatedAt:"",updatedBy:""},
        status:0,
        createdAt:"",
        createdBy:"",
        updatedAt:"",
        updatedBy:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const TOKENData = (state = intialTOKENData, action: any) => {
    
    switch (action.type) {
       
        case SAVE_TOKEN_STARTED:
           // alert("check");
           return {
                ...state,
                isLoading: true,    
                isFormSubmit:true,
                TOKENInput: action.input
                
            };

        case SAVE_TOKEN_COMPLETED:
             return {
                ...state,
                isLoading: false,
                isFormSubmit:true,
                status: action.payload
                };
            
        case SAVE_TOKEN_FAILED:
            return {
                ...state,
                isLoading: true,
            };

        default:
            return state;
    }
};
